// extracted by mini-css-extract-plugin
export default {"container":"Section_container__cnLc7","header":"Section_header__xBxz3","title":"Section_title__69-EP","content":"Section_content__tAiUx"};